import React from 'react';
import RegistrationCodeInputField from './RegistrationCodeInputField';
import { getIntl } from '../../../utils/intl';
import usePayments from '../../../hooks/api/usePayments';
import { ContentStack } from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import useRecordEvent from '../../../hooks/useRecordEvent';

const intl = getIntl('RegistrationCodePromptContents', {
    invitationOrCouponCodeSubText:
        'Codes will be used to apply credits or discounts to your account. They may also be used to allow a partner to share resources.',
});

export type RegistrationCodePromptContentsOwnProps = {
    onClosePrompt: () => void;
};

export type RegistrationCodePromptContentsProps = RegistrationCodePromptContentsOwnProps;

const RegistrationCodePromptContents: React.FC<RegistrationCodePromptContentsProps> = ({}) => {
    const recordEvent = useRecordEvent();
    const { applyRegistrationCode, isApplyingRegistrationCode } = usePayments({
        onRegistrationCodeApplied: (code) => {
            recordEvent('registrationCodeApplied', {
                appliedRegistrationCode: code,
            });
        },
    });
    return (
        <ContentStack>
            <Text variant="body-1">{intl('invitationOrCouponCodeSubText')}</Text>
            <RegistrationCodeInputField
                isApplyingRegistrationCode={isApplyingRegistrationCode}
                onSubmit={(code) => {
                    applyRegistrationCode({ code });
                }}
            />
        </ContentStack>
    );
};

export default React.memo(RegistrationCodePromptContents);
